import useStore from '../Store/market_greeks_data_store';

export const customIndicatorsGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX Market GEX',
      metainfo: {
        _metainfoVersion: 53,
        id: 'SPX Market GEX@tv-basicstudies-5', // bump to avoid saved-style collisions
        description: 'SPX Market GEX',
        shortDescription: 'SPX Market Gex',
        linkedToSeries: false,
        is_price_study: false,
        format: { type: 'inherit' },

        // Outline + two area series (pos/neg), fills go to histogramBase: 0
        plots: [
          { id: 'zline', type: 'line', title: 'z_5ma (line)', trackPrice: false, fillGaps: true },
          { id: 'gex_pos', type: 'line', title: 'Positive Area', trackPrice: false, fillGaps: true },
          { id: 'gex_neg', type: 'line', title: 'Negative Area', trackPrice: false, fillGaps: true },
        ],

        defaults: {
          styles: {
            // always-visible outline of z_5ma
            zline: {
              linestyle: 0,
              linewidth: 1,
              plottype: 0,         // line
              trackPrice: false,
              transparency: 0,
              visible: true,
              color: '#9bb1ff',
            },

            // positive area (single color gradient to 0)
            gex_pos: {
              linestyle: 0,
              linewidth: 2,
              plottype: 8,         // area (same as your GTS code)
              areaStyle: 1,        // enable area fill style
              trackPrice: false,
              transparency: 35,    // tweak to taste (0..100)
              visible: true,
              color: '#24d4ff',    // positive hue
            },

            // negative area (single color gradient to 0)
            gex_neg: {
              linestyle: 0,
              linewidth: 2,
              plottype: 8,         // area
              areaStyle: 1,
              trackPrice: false,
              transparency: 35,
              visible: true,
              color: '#d90d7a',    // negative hue
            },
          },

          precision: 2,
          inputs: {}
        },

        styles: {
          // fill down/up to zero
          gex_pos: { title: 'GEX (+)', histogramBase: 0, areaStyle: 1, joinPoints: true },
          gex_neg: { title: 'GEX (−)', histogramBase: 0, areaStyle: 1, joinPoints: true },
          zline:   { title: 'z_5ma (line)', joinPoints: true },
        },

        inputs: []
      },

      constructor: function () {
        this._lastSign = 0; // -1, 0, +1

        this.init = function (ctx) {
          this._context = ctx;

          const spxGexData = useStore.getState().spxGexData || [];
          if (!spxGexData || spxGexData.length === 0) {
            this._z5maData = [];
            return;
          }

          // Shift + convert ms->s to align with your chart setup
          const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
          this._z5maData = spxGexData.map(entry => {
            const value = entry.z_5ma == null ? 0 : parseFloat(entry.z_5ma);
            return {
              time: Math.floor((entry.time + ONE_DAY_IN_MS) / 1000),
              value
            };
          });
        };

        this.main = function (ctx) {
          // Return order: [zline, gex_pos, gex_neg]
          const EMPTY = [NaN, 0, 0];
          if (!this._z5maData || this._z5maData.length === 0) return EMPTY;

          const currentTime = Math.floor(ctx.symbol.time / 1000);
          if (!Number.isFinite(currentTime)) return EMPTY;

          // nearest-time lookup (preserve your behavior)
          let closest = null;
          let smallest = Infinity;
          for (const d of this._z5maData) {
            const diff = Math.abs(d.time - currentTime);
            if (diff < smallest) { smallest = diff; closest = d; }
          }
          if (!closest) return EMPTY;

          const vRaw = Number.isFinite(closest.value) ? closest.value : 0;

          // --- seam-free sign handling ---
          // Keep a tiny presence at zero on the "active" side to avoid the black void at transitions.
          const EPS = 1e-6;                // micro-overlap (in plot units)
          const ZERO_BAND = 1e-9;          // how close to treat as zero for sign latch
          let sign = (vRaw > ZERO_BAND) ? 1 : (vRaw < -ZERO_BAND) ? -1 : this._lastSign || 0;

          // update last sign when we have a real non-zero value
          if (Math.abs(vRaw) > ZERO_BAND) this._lastSign = sign;

          // build area values
          // - if sign > 0: ensure at least EPS on the positive side (even if vRaw ~ 0)
          // - if sign < 0: ensure at least -EPS on the negative side
          let pos = 0, neg = 0;
          if (sign >= 0) {
            pos = (vRaw > 0) ? vRaw : EPS;   // tiny positive film when near zero
            neg = 0;
          } else {
            pos = 0;
            neg = (vRaw < 0) ? vRaw : -EPS;  // tiny negative film when near zero
          }

          // Outline shows the actual value (no EPS)
          return [vRaw, pos, neg];
        };

        this.destroy = function () {};
      }
    }
  ]);
};


// import useStore from '../Store/market_greeks_data_store';
//
// export const customIndicatorsGetter = function (PineJS) {
//   return Promise.resolve([
//     {
//       name: 'SPX Market GEX',
//       metainfo: {
//         _metainfoVersion: 53,
//         id: "SPX Market GEX@tv-basicstudies-1",
//         description: "SPX Market GEX",
//         shortDescription: "SPX Market Gex",
//         format: { type: "inherit" },
//         linkedToSeries: false,
//         is_price_study: false,
//         plots: [
//           { id: "z5ma_plot", type: "line" },
//           { id: "plot_baseline", type: "line" }
//         ],
//         defaults: {
//           styles: {
//             z5ma_plot: {
//               linestyle: 0,
//               linewidth: 1,
//               plottype: 4, // Default to area plot
//               trackPrice: false,
//               transparency: 60, // 20% opacity
//               visible: true,
//               color: "rgba(36,212,255,0.82)", // Green for positive values
//
//             },
//             plot_baseline: {
//               linestyle: 0,
//               linewidth: 1, // Ensure baseline is visible
//               transparency: 0,
//               color: "#ffffff", // White baseline
//             },
//           },
//         },
//         styles: {
//           z5ma_plot: { title: "z_5ma", histogramBase: 0, joinPoints: true },
//           plot_baseline: { title: "Baseline" },
//         },
//         inputs: [], // No user input needed for a fixed baseline
//       },
//       constructor: function () {
//         this.init = function (ctx) {
//           this._context = ctx;
//           const spxGexData = useStore.getState().spxGexData || [];
//
//           if (!spxGexData || spxGexData.length === 0) {
//             this._z5maData = [];
//             return;
//           }
//
//           const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
//
//           this._z5maData = spxGexData
//             .map(entry => {
//               const value = entry.z_5ma === null ? 0 : parseFloat(entry.z_5ma);
//
//               // Shift the timestamp forward by one day to force correct alignment
//               return {
//                 time: Math.floor((entry.time + ONE_DAY_IN_MS) / 1000),
//                 value: value,
//               };
//             });
//
//           // console.log('Shifted z_5ma data:', this._z5maData);
//         };
//
//         this.main = function (ctx) {
//           const currentTime = Math.floor(ctx.symbol.time / 1000); // Convert to seconds
//           // console.log('Running main method of the Custom z_5ma Indicator...');
//           // console.log('Current time from context:', currentTime);
//
//           if (!this._z5maData || this._z5maData.length === 0) {
//             // console.warn('No z_5ma data available.');
//             return [NaN, 0]; // Return baseline at 0 even if data is missing
//           }
//
//           // Find the closest matching `time` in `z5maData`
//           let closestMatch = null;
//           let smallestDiff = Infinity;
//           for (const data of this._z5maData) {
//             const timeDiff = Math.abs(data.time - currentTime);
//             if (timeDiff < smallestDiff) {
//               closestMatch = data;
//               smallestDiff = timeDiff;
//             }
//           }
//
//           if (closestMatch) {
//             // console.log(
//             //   `Found closest z_5ma value: ${closestMatch.value} for time: ${closestMatch.time}`
//             // );
//
//             // Return the value for the plot and 0 for the baseline
//             return [closestMatch.value, 0];
//           }
//
//           // console.warn(`No close match found for the current time (${currentTime}). Returning NaN.`);
//           return [NaN, 0]; // Return baseline at 0 even if no match
//         };
//       },
//     },
//   ]);
// };




















